import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrafo2X = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5624 7.36648L16.5756 7.34861L16.6081 19.3311C16.6069 19.4714 16.4904 19.5857 16.3501 19.5845L14.4334 19.565C14.2931 19.5637 14.1787 19.4473 14.18 19.307L14.1452 7.32675L12.1673 7.30897C11.9546 7.30705 11.8369 7.05931 11.9697 6.89303L15.2037 2.86885C15.3089 2.73854 15.5058 2.74257 15.6065 2.87247L18.7676 6.95417C18.7968 6.99225 18.8147 7.03775 18.8193 7.08551C18.8239 7.13327 18.815 7.18136 18.7936 7.22431C18.7723 7.26727 18.7393 7.30337 18.6984 7.3285C18.6575 7.35363 18.6104 7.36679 18.5624 7.36648Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75377 21.0179L4.60786 22.5985L14.2817 17.4439C14.3957 17.3848 14.5391 17.4281 14.5994 17.5397L15.4215 19.0654C15.4818 19.177 15.4376 19.3174 15.3236 19.3765L5.65263 24.5319L6.50283 26.1052C6.59427 26.2745 6.44543 26.4737 6.25296 26.4398L1.5856 25.602C1.43422 25.5744 1.35143 25.4169 1.41245 25.2816L3.33074 21.032C3.34876 20.9926 3.37772 20.9589 3.41432 20.9348C3.45092 20.9107 3.49369 20.8972 3.53776 20.8957C3.58184 20.8943 3.62545 20.9049 3.66363 20.9265C3.70182 20.9481 3.73305 20.9798 3.75377 21.0179Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9263 20.982L26.0769 22.5538L16.4564 17.4277C16.3431 17.369 16.2005 17.412 16.1405 17.523L15.3229 19.0403C15.263 19.1513 15.3069 19.2909 15.4202 19.3496L25.0379 24.4766L24.1924 26.0413C24.1014 26.2095 24.2495 26.4077 24.4409 26.3739L29.0825 25.5408C29.233 25.5134 29.3154 25.3567 29.2547 25.2221L27.347 20.996C27.329 20.9568 27.3002 20.9233 27.2638 20.8994C27.2274 20.8754 27.1849 20.8619 27.1411 20.8605C27.0973 20.859 27.0539 20.8696 27.0159 20.8911C26.9779 20.9126 26.9469 20.9441 26.9263 20.982Z",
			fill: "currentColor"
		})
	]
});
export default SvgTrafo2X;
